import { Box, Link, Typography } from '@mui/material';

import GoLogo from '@/components/GoLogo';
import { SUPPORT_EMAIL } from '@/constants/constants';
import DefaultLayout from '@/layouts/DefaultLayout';

export const MaintenanceMode = () => {
  return (
    <DefaultLayout>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          gap: 1,
          pt: '32px'
        }}
      >
        <GoLogo />
        <Typography
          sx={{
            mt: '32px',
            fontSize: '36px',
            fontWeight: 'bold'
          }}
        >
          We'll be back soon
        </Typography>
        <Typography
          sx={{
            fontSize: '20px'
          }}
        >
          GX Go is down for scheduled maintenance <br />
          and and will be back online shortly.
        </Typography>
        <Typography
          sx={{
            fontSize: '20px'
          }}
        >
          Once complete, you'll be automatically redirected
          <br />
          to the GX Go webpage.
        </Typography>

        <Typography>
          Need assistance? Drop us a line at{' '}
          <Link
            href={`mailto:${SUPPORT_EMAIL}`}
            sx={{ cursor: 'pointer', textDecoration: 'underline', color: 'white' }}
          >
            {SUPPORT_EMAIL}
          </Link>
        </Typography>
        <Link
          color='text.primary'
          href='https://www.general-index.com'
          sx={{
            backgroundColor: 'primary.main',
            fontSize: '14px',
            textDecoration: 'none',
            padding: '8px 16px',
            marginTop: '24px',
            minWidth: '250px'
          }}
          target='_blank'
        >
          Visit our website
        </Link>
      </Box>
    </DefaultLayout>
  );
};
